import { memoize } from 'proxy-memoize'
import { Discount } from './types.ts'
import { DISCOUNT_STATUSES } from '@boltenergy-be/shared'

/**
 * Selects active discounts from a list of discounts.
 * @param {Discount[]} discounts
 * @returns {Discount[]}
 */
const selectActiveDiscounts = (discounts: Discount[]): Discount[] => {
  return discounts?.filter((discount) => discount.status === DISCOUNT_STATUSES.active) || []
}
export const memoizedSelectActiveDiscounts = memoize<Discount[], Discount[]>(selectActiveDiscounts)
